import { Checkbox } from "@atlas-design-system/react";
import { actionButtons } from "./actionButtons";

export const excludeColumns = [
    {
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'select',
        header: ({ table }) => (
            <Checkbox
                label=''
                {...{
                    checked: table.getIsAllRowsSelected(),
                    indeterminate: table.getIsSomeRowsSelected(),
                    onChange: table.getToggleAllRowsSelectedHandler()
                }}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                label=''
                {...{
                    checked: row.getIsSelected(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler()
                }}
            />
        )
    },
    {
        header: () => 'Airline code',
        accessorKey: 'airlineCode',
        editable: true,
        required: true,
        regEx: new RegExp('^\\w{2}$', 'm'),
        regExMessage: 'Airline code must be 2 alphanumeric'
    },
    {
        header: () => 'PCC',
        accessorKey: 'pcc',
        editable: true,
        required: true,
        regEx: new RegExp('^\\w{3,4}$', 'm'),
        regExMessage: 'PCC code must be 3-4 alphanumeric'
    },
    {
        header: () => 'Deal code',
        accessorKey: 'dealCode',
        editable: true
    },
    {
        enableColumnFilter: false,
        header: () => 'Timestamp',
        accessorKey: 'timestamp',
        cell: (info) => new Date(info.getValue()).toLocaleString(),
        sortingFn: (rowA, rowB, columnId) =>
            {
                var dateA = new Date(rowA.original[columnId]);
                var dateB = new Date(rowB.original[columnId]);
                if(dateA < dateB) return -1;
                if(dateA > dateB) return 1;
                return 0;
            }
    },
    {
        enableSorting: false,
        enableColumnFilter: false,
        header: () => 'Actions',
        accessorKey: 'actions',
        meta: {
            align: 'right'
        },
        cell: (info) => actionButtons(info)
    }
];

